import { FC } from 'react';
import type { TechnicalErrorWithoutPriceTileData } from 'state/quotes/dashboard/model';

import { PricingDate, ResultPanel, SolveModeLabel, TechnicalError, TileLayout } from './components';
import type { TileContentProps } from './Tile.common';

export const TechnicalErrorWithoutPriceTile: FC<TileContentProps<TechnicalErrorWithoutPriceTileData>> = ({
  quoteId,
  data,
  header,
  subHeader,
  footer,
}) => {
  return (
    <TileLayout header={header} subHeader={subHeader} footer={footer}>
      <ResultPanel
        color="danger"
        solveModeLabel={<SolveModeLabel value={data.solveMode} size="normal" />}
        statusPanel={<TechnicalError id={quoteId} value={data.errorMessage} />}
        subHeader={<PricingDate when={data.lastUpdated} />}
      />
    </TileLayout>
  );
};

TechnicalErrorWithoutPriceTile.displayName = 'TechnicalErrorWithoutPriceTile';
